import { State } from '../StateTypes';
import { SheetObject, SheetQueue } from './sheetTypes';

export const selectSheetQueue = (state: State): SheetQueue =>
  state.sheets.queue;

export const selectLatestSheetInQueue = (
  state: State
): SheetObject | undefined =>
  selectSheetQueue(state)[selectLatestSheetIndex(state)];

export const selectLatestSheetIndex = (state: State): number => {
  const queueLength = selectSheetQueue(state).length;
  return queueLength > 0 ? queueLength - 1 : queueLength;
};
